import { PCCSchedulerControlFilters } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/types';
import { SchedulerDateNavigationSection } from '@lp/features/Scheduler/components';
import { CCResourcesWithShifts } from '@/api/apis/resources/schedule';
import { UseFiltersType } from '@/hooks/useFilters';
import { PCCSchedulerFiltersSection } from './components';

type PCCSchedulerControlRowProps = {
  selectedDate: Date;
  shiftsData: CCResourcesWithShifts;
  filters: UseFiltersType<PCCSchedulerControlFilters>;
  onDateChange: (date: Date) => void;
};

export const PCCSchedulerControlRow = ({
  filters,
  shiftsData,
  selectedDate,
  onDateChange,
}: PCCSchedulerControlRowProps) => {
  return (
    <div className="flex items-center gap-2 justify-between">
      <SchedulerDateNavigationSection selectedDate={selectedDate} onDateChange={onDateChange} />
      <PCCSchedulerFiltersSection shiftsData={shiftsData} filters={filters} />
    </div>
  );
};
